var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21,7H8l-1,1v13l1,1h13l1-1V8l-1-1Zm-1,13H9V9h11v11ZM4,15h1v2H3l-1-1V3l1-1h13l1,1v2h-2v-1H4V15Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/1769707387/media/icon-copy.5bb73d898313863cb84111b1d57473e4.svg";
export { ForwardRef as ReactComponent };